import React from "react";

import moment from "moment";

interface GridCellDateProps {
  object: {
    created_at: string;
    updated_at: string;
  };
  type?: "created_at" | "updated_at";
  withoutSuffix?: boolean;
}

export default function GridCellDate({ object, type = "created_at", withoutSuffix = true }: GridCellDateProps) {
  return <span className="text-[12px]">{moment(type === "created_at" ? object.created_at : object.updated_at).fromNow(withoutSuffix)}</span>;
}
